import { render, staticRenderFns } from "./SimulasiPembayaran.vue?vue&type=template&id=54f3911c&"
import script from "./SimulasiPembayaran.vue?vue&type=script&lang=js&"
export * from "./SimulasiPembayaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports